import mapConnection from '../utils/connectionMapper';
import _ from 'lodash';

export default function mapCPTs(claim) {
  const documentsConnection = _.get(
    claim,
    'legalFormalNotice.documentsConnection'
  );
  const claimsPassengerTickets = claim
    ? mapConnection(claim.claimsPassengerTicketConnection)
    : [];

  const legalFormalNotice = documentsConnection
    ? mapConnection(claim.legalFormalNotice.documentsConnection).map(
        node => node.id
      )
    : [];

  const documents = [].concat.apply(
    [],
    claimsPassengerTickets
      ? claimsPassengerTickets
          .map(claimPassengerTicket =>
            mapConnection(claimPassengerTicket.documentsConnection)
          )
          .filter(node => node.length > 0)
      : []
  );

  return { claimsPassengerTickets, legalFormalNotice, documents };
}



// WEBPACK FOOTER //
// ./src/utils/mapCPTs.js